import { padStart } from 'lodash';
import { isArray } from 'util';

const MONTHS = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');

// Numeric
export const integer = Math.floor;
export const round1 = value => Math.floor(value * 10) / 10;
export const round2 = value => Math.floor(value * 100) / 100;
export const ratioToPercent = ratio =>
  typeof ratio === 'number' ? `${roundPercent(ratio)}%` : 'N/A';
export const ratioToPercentPlus = (ratio, digits) =>
  typeof ratio === 'number' ? `${roundPercentPlus(ratio, digits)}%` : 'N/A';
export const roundPercent = value => Math.floor(value * 1000) / 10;
export const roundPercentPlus = (value, digits) =>
  Number.parseFloat((value * 100).toFixed(digits));
export const per100 = value => round2(value * 100).toFixed(2);
export const round1Display = value => value.toFixed(1);
export const round2Display = value => value.toFixed(2);
export const roundXDisplay = (value, x) => value.toFixed(x);

// Games
export function gameTitle(game) {
  const home = game.home.team;
  const visitor = game.visitor.team;

  const home_name_short = teamNameShort(home);
  const visitor_name_short = teamNameShort(visitor);

  return `${home_name_short} vs ${visitor_name_short}`;
}

export function timeToClock(time) {
  const minutes = Math.floor(time);
  const seconds = padStart(
    ((time - Number.parseFloat(Math.floor(time))) * 60).toFixed(0),
    2,
    '0',
  );
  return `${minutes}:${seconds}`;
}

export function teamNameShort(team) {
  if (team) {
    const team_name_short =
      team.name_short !== '0'
        ? team.name_short
        : team.name.substr(0, 3).toUpperCase();
    return team_name_short;
  } else {
    return '';
  }
}

export function teamName(team) {
  if (team) {
    return team.name;
  } else {
    return teamNameShort(team);
  }
}

export function seasonName(season) {
  if (season) {
    return season.name;
  } else {
    return 'Unknown Season';
  }
}

export function createOverflow(team, season) {
  let overflow = team && {
    text: `${season ? season.name : 'Unknown'} Season`,
    lines: [],
  };
  if (team && team.conference)
    overflow.lines.push(
      team.conference.description
        ? `${team.conference.description}`
        : `${team.conference.division.name} / ${team.conference.name}`,
    );
  if (team && team.records) {
    for (let record of team.records) {
      if (record.season.id === season.id) {
        overflow.lines.push(
          `Record ${record.description} · ${record.wins}-${record.losses}`,
        );
      }
    }
  }
  return overflow;
}

// Dates

/**
 * Format a date to something like 'NOV 15TH 2019'
 * @param {*} str
 */
export function formatDate(str) {
  const { monthName, day, year } = parseDate(str);
  return `${day} ${monthName} ${year}`;
}

export function formatPlayers(players) {
  return players.map(formatPlayer).join(' - ');
}

export function formatPlayer(player) {
  return `${player.jersey} ${player.name}`;
}

export function formatMonthYear(str) {
  const { monthName, year } = parseDate(str);
  return `${monthName} ${year}`;
}

function parseDate(str) {
  try {
    const date = new Date(str);
    const month = date.getMonth();
    const monthName = MONTHS[month];
    const day = date.getDate();
    const year = date.getFullYear();
    return { day, month, year, monthName };
  } catch (e) {
    return {};
  }
}

export function formatGameIds(value) {
  if (isArray(value)) {
    value = value.map(mapped => mapped.value).join(',');
  }
  return value;
}

export function checkIfNBA(team) {
  if (!team) return;
  const nbaLeague = team.leagues.find(l =>
    l.name.toLowerCase().includes('nba'),
  );
  return nbaLeague ? true : false;
}

export function checkIfNCAA(team) {
  if (!team) return;
  const ncaaLeague = team.leagues.find(l =>
    l.name.toLowerCase().includes('ncaa'),
  );
  return ncaaLeague ? true : false;
}
